import { Redirect, router, useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
    FontFamilyName,
    FruitfulLogo,
    ScrollView,
    Text,
    useThemeColors,
    View,
    YStack,
} from 'smoothie';

import { ConvMmAccountForm } from '../../auth/components/new-member/ConvMmAccountForm';
import { isUserSetupInProgressAtom } from '../../auth/state/AuthAtoms';
import { VisitorProvider } from '../../user/providers/VisitorProvider';

const CONTENT_MAX_WIDTH = 480;

// Standalone ConvMmAccountForm preview — bypasses the CMM branch
export default function ConvMmAccountFormDevPage() {
    const { getColor } = useThemeColors();
    const setIsUserSetupInProgress = useSetAtom(isUserSetupInProgressAtom);
    const searchParams = useLocalSearchParams();

    const handleSuccess = useCallback(
        (_email: string) => {
            setIsUserSetupInProgress(true);
            router.push({
                pathname: '/sign-up/new-member/info',
                params: searchParams,
            });
        },
        [searchParams, setIsUserSetupInProgress],
    );

    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <VisitorProvider>
            <View height="100%" width="100%">
                <ScrollView
                    height="100%"
                    width="100%"
                    contentContainerStyle={{ flexGrow: 1 }}
                    keyboardShouldPersistTaps="handled"
                >
                    <YStack
                        width="100%"
                        maxWidth={CONTENT_MAX_WIDTH}
                        alignSelf="center"
                        alignItems="center"
                        paddingVertical={24}
                        paddingHorizontal={24}
                        gap={24}
                        $sm={{ paddingHorizontal: 32 }}
                    >
                        <FruitfulLogo
                            width={40}
                            height={34}
                            color={getColor('$leaf')}
                        />
                        <Text
                            fontSize={32}
                            lineHeight="90%"
                            letterSpacing={-1.6}
                            textAlign="center"
                            style={{
                                fontFamily: FontFamilyName.SourceSerifRegular,
                            }}
                        >
                            Create your account
                        </Text>
                        <ConvMmAccountForm
                            onSuccess={handleSuccess}
                            artifactFinalPageSegment="account"
                        />
                    </YStack>
                </ScrollView>
            </View>
        </VisitorProvider>
    );
}
